module.exports = __webpack_public_path__ + "static/media/icon_close_simple_dark.ac51d447.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_close_simple_dark.png
// module id = 514
// module chunks = 0